var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "base-list" } },
    [
      _c("lb-table", {
        attrs: {
          column: _vm.baseColumns,
          data: _vm.baseList,
          pagination: "",
          total: _vm.page.totalNum,
          layout: "total, sizes, prev, pager, next, jumper",
          "page-sizes": [5, 10, 20, 30, 50],
          "current-page": _vm.page.currentPage,
          "page-size": _vm.page.pageSize,
        },
        on: {
          "update:currentPage": function ($event) {
            return _vm.$set(_vm.page, "currentPage", $event)
          },
          "update:current-page": function ($event) {
            return _vm.$set(_vm.page, "currentPage", $event)
          },
          "selection-change": _vm.onMultipleSelection,
          "size-change": _vm.handleSizeChange,
          "p-current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }